import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData, sanitizePageDataSearch } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ProductListPageInitialData } from "./productListPageInitialData";

export const categoryPageQueryOptions = (categoryCode: string, search = "") => {
  const sanitizedSearch = sanitizePageDataSearch(search);
  return queryOptions({
    queryKey: pageDataKeys.category(categoryCode, sanitizedSearch),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<ProductListPageInitialData>>(
        `/page-data/c/${categoryCode}${sanitizedSearch}`,
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
